import { LIVE_FLAG_LABEL } from "../Variants/VerticalToHorizontalCard/constants";
import Badge from "../../Badge";
import { BadgeTypes } from "../../Badge/interface";

export const getBadge = (
    status: string | undefined,
    label: string | undefined,
    className: string | undefined
) => {
    if (status?.toLowerCase() === LIVE_FLAG_LABEL) {
        return (
            <Badge text={"LIVE"} type={BadgeTypes.Live} className={className} />
        );
    }

    return (
        label && (
            <Badge text={label} type={BadgeTypes.Topic} className={className} />
        )
    );
};

export const getStatus = (
    status: string | undefined,
    className: string | undefined
) => {
    if (status?.toLowerCase() === LIVE_FLAG_LABEL) return;

    return status && <span className={className}>{`${status} `}</span>;
};
